import React from 'react';
import PropTypes from 'prop-types';
import BrowserStore from 'store2';
import fetch from 'isomorphic-fetch';
import {connect} from 'react-redux';
import Dropzone from 'react-dropzone';
import { modal } from 'react-redux-modal';
import {checkHttpStatus, parseJSON} from '../../../utils';
import { updateAvatarUri } from '../../../actions/currentUser';
import './styles.scss';
import ExploreAuth from '../../../utils/ExploreAuth';
import SuccessfulRegistrationModal from '../SuccessfulRegistrationModal';
import { modalViewGA } from '../../../utils/googleAnalytics';

const propTypes = {
  registrationSuccess: PropTypes.bool,
  afterAcceptCallback: PropTypes.func,
}

const defaultProps = {
  registrationSuccess: false,
  afterAcceptCallback: () => {},
}

class UploadAvatar extends React.Component {

  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.submitAvatar = this.submitAvatar.bind(this);
    this.state = { avatarUri: null, username: null }
  }

  closeModal(e) {
    if (e) e.preventDefault();
    this.props.removeModal();

    if (this.props.registrationSuccess) {
      modal.add(SuccessfulRegistrationModal, {
        title: '',
        size: 'medium',
        hideTitleBar: true,
      });
    }
  }

  componentDidMount() {
    modalViewGA('upload-avatar');
  }

  onDrop(accepted, rejected) {
    if (accepted.length > 0) {
      const currentToken = BrowserStore.get('token');
      return ExploreAuth.getValidJwt()
        .then((tokenIsValid) => {
          // Token can't be refreshed log them out
          if (!tokenIsValid) {
            // We should probably add a modal here informing them they need to log back in.
            //return dispatch(authLogoutAndRedirect());
          }
          const formData = new FormData();
          accepted.forEach(file => {
            if (file.size > 1048576) {
              alert('File size is too large. Please upload a file less than 1MB');
              return;
            }

            formData.append('image', file);
            fetch(`${SERVER_URL}/accounts/upload_avatar`, {
              method: 'post',
              credentials: 'same-origin',
              headers: {
                Authorization: `Bearer ${ExploreAuth.getJwt()}`,
              },
              body: formData,
            })
              .then(checkHttpStatus)
              .then(parseJSON)
              .then(function (response) {
                this.setState({ avatarUri: response.data.avatar_uri, username: response.data.username });
              }.bind(this))
              .catch((error) => {
                // debugger;
                console.error(error);
              });
          });
        });
    }
  }

  submitAvatar() {
    this.props.dispatch(updateAvatarUri(this.state.avatarUri));
    this.props.afterAcceptCallback(this.state.avatarUri);
    this.closeModal();
  }

  render() {
    const { avatarUri, username } = this.state;
    const { registrationSuccess } = this.props;
    const style = (avatarUri) ? {
      backgroundImage: `url("${avatarUri}")`,
      backgroundColor: 'transparent',
    } : {}

    let dropzoneRef;


    return (
      <div>
        <div className="modals-popup upload-avatar-modal u-font-foundation-roman">
          <div className="modal-header d-flex align-items-center">
            <div className="col">Upload a Profile Photo</div>
          </div>

          <div className="info text-center">
            <div className="row align-items-center">
              <div className="col-md-6 font-weight-bold p-30">
                {registrationSuccess && ! avatarUri && (
                  <h4 className="pb-2"> You have been successfully registered!</h4>
                )}
                {avatarUri ? 'Excellent Choice!' : 'Choose a beautiful photo to represent you on Explore.'}
              </div>
              <div className="col-md-6">
                <Dropzone ref={(node) => {
                  dropzoneRef = node;
                }} accept="image/jpeg, image/png" className="avatar-upload" style={style} onDrop={this.onDrop}
                          multiple={false}>
                  {!avatarUri &&
                  <div>Photo will be resized to a square 160 x 160</div>
                  }
                </Dropzone>
              </div>
            </div>
            {avatarUri ? (
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="btn btn-primary" onClick={() => { dropzoneRef.open()}}>Change Photo</div>
                </div>
                <div className="col-md-6">
                  <div className="btn btn-primary" onClick={this.submitAvatar}>Accept Photo</div>
                </div>
              </div>
            ) : (
              <div className="row align-items-center">
                <div className="col-md-6">
                  {registrationSuccess && (
                    <span className="skip-text u-testSize-16" onClick={this.closeModal}>Do Later</span>
                  )}
                </div>
                <div className="col-md-6">
                  <div className="btn btn-primary"
                       onClick={() => { dropzoneRef.open()}}
                  >
                    Choose Photo
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    registrationSuccess: ownProps.registrationSuccess,
  };
}

UploadAvatar.propTypes = propTypes;
UploadAvatar.defaultProps = defaultProps;

export default connect(mapStateToProps)(UploadAvatar);
